import ZCanvas from './ZCanvas.js';
import {getAllNodesInSub} from 'utils/findNode.js';
import {definitions} from './canvas3d/index.js';
import * as THREE from "three";

let CANVASES = [];
export default class ZCanvas3D extends ZCanvas {
    constructor(zobject) {
        super(zobject);
        CANVASES.push(this);
        this.newInlet("render target", ([target]) => this.onRenderTarget(target));
        this.newInlet("get image data", ([target]) => this.onGetImageData());
        this.newOutlet("mouse-move");
        this.newOutlet("mouse-click");
        this.newOutlet("mouse-down");
        this.newOutlet("isMouseDown");
        this.newOutlet("size");
        this.newOutlet("image data");
    }

    onGetImageData() {
        if (this.ctxt) {
            let temp1 = this.ctxt;
            let len = this.zObject.width * this.zObject.height * 4 * 16;
            if (!this.pixels || this.pixels.length !== len) {
                this.pixels = new Uint8Array(len);
            }
            let pixels = this.pixels;
            temp1.getContext().readPixels( 0, 
                                           0, 
                                           temp1.getContext().drawingBufferWidth, 
                                           temp1.getContext().drawingBufferHeight, 
                                           temp1.getContext().RGBA, 
                                           temp1.getContext().UNSIGNED_BYTE, 
                                           pixels)
            let indices = [];
            for (let i=0; i < pixels.length; i+=4) {
                if (pixels[i] > 0) {
                    indices.push(i/4);
                }
            }
            this.sendMessage("image data", pixels);
        }
    }

    onMouseDown(x,y) {
        this.sendMessage("mouse-down", [x,y]);
        this.sendMessage("isMouseDown", 1);
    }

    onMouseUp() {
        this.sendMessage("isMouseDown", 0);
    }

    enqueue(fn, operation, ...vargs) {
        this.queue.push({fn, operation, vargs});
    }

    onMouseMove(x,y) {
        this.sendMessage("mouse-move", [x,y]);
    }

    onMouseClick(x,y) {
        this.sendMessage("mouse-click", [x,y]);
    }



    get width() {
        return this.zObject.width;
    }

    get height() {
        return this.zObject.height;
    }

    onRenderTarget(renderTarget) {
        console.log("on render target called=", renderTarget);
        if (this.renderer) {
            let t = !renderTarget || renderTarget === "null" ? null : renderTarget;
            this.enqueue(
                () => {
                    console.log('setting render target=', t);
                    this.renderer.setRenderTarget(t);
                },
                "setRenderTarget",
                [t]
            );
            
        }
    }

    getFunctionDefinition(name) {
        return definitions[name];
    }

    draw() {
        window.zRender.push(new Date().getTime() - window.requestedTime);
        window.lastRenderTime = new Date().getTime();
        let queue = this.dedupeQueue(this.queue);
        if (queue.length === 0) {
            this.requested=false;
            if (this === CANVASES[0]) {
                // only first canvas requests
                window.requestAnimationFrame(() => CANVASES.forEach(x => x.draw()));
            }
            return;
        }
        window.renderSize.push(queue.length);
        let errors = [];
        queue.forEach(({fn}) => {
            let err = fn();
            if (err) {
                errors = [...errors, ...err];
            }
        });

        if (this.lastErrorsLength !== errors.length) {
            if (errors.length > 0) {
                this.scripts.forEach(
                    x => x.effect.onNewErrors(errors));
            } else {
                this.scripts.forEach(
                    x => x.effect.clearErrors(errors));
            }
            this.lastErrorsLength = errors.length;
        }

        // look for all shaders
        
        this.queue.length = 0;
        this.requested=false;
        if (this === CANVASES[0]) {
            window.requestAnimationFrame(() => CANVASES.forEach(x => x.draw()));
        }
    }

    get scripts() {
            return getAllNodesInSub(
                this.subSequence.getRootSubSequence ? this.subSequence.getRootSubSequence() : this.subSequence)
                .filter(
                    x => x.name === 'script');
    }

    dedupeQueue(queue) {
        let previous;
        let _queue = [];
        for (let action of queue) {
            let {fn, operation, vargs} = action;

            if (previous) {
                if (operation === previous.operation &&
                    vargs.every((a,i) => a === previous.vargs[i])) {
                    // then we skip
                    continue;
                }
            }

            _queue.push(action);

            previous = action;
        }
        return _queue;
    }

    fromJson(...args) {
        let json = super.fromJson(...args);
        
        return json;
    }
}
